<div class="row top-wrap" *ngIf="showAdContainer">

</div>



// WEBPACK FOOTER //
// /app/src/app/components/top-nav-bar/top-nav-bar.component.html